import type { GQL_ID } from '@@partner:types:graphql'
import type { UploaderProps } from 'rsuite'

import React, { useCallback } from 'react'
import { notifyError, notifyOk } from '@@partner:helpers/notification'

import { Uploader } from 'rsuite'
import FileUploadIcon from '@rsuite/icons/FileUpload'

export interface DropzoneUploaderProps extends UploaderProps {
  action: string
  name: string
  onUploaded?: (fileId: GQL_ID, url: string) => void
  onRemoved?: () => void
  imageStyle?: string
  containerStyle?: React.CSSProperties
  data?: Record<string, string | undefined>
}

export const DropzoneUploaderDescription = () => {
  return (
    <div className="text-gray-500">
      <FileUploadIcon className="text-3xl mx-2 " />
      Нажмите или перенесите изображения в эту область
    </div>
  )
}

export default function DropzoneUploader ({
  action,
  name,
  onUploaded,
  children = <DropzoneUploaderDescription />,
  multiple,
  imageStyle,
  containerStyle,
  data: extraData
}: DropzoneUploaderProps) {
  const handleUploadSuccess = useCallback(
    ({ id, url }) => {
      notifyOk('Файл загружен!')
      onUploaded?.(id, url)
    },
    [ onUploaded ]
  )

  const handleUploadError = useCallback((error) => {
    notifyError('Ошибка загрузки файла', error.response)
  }, [])

  const computedContainerStyle = {
    minHeight: '150px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...containerStyle
  }


  return (
    <Uploader
      action={action}
      name={name}
      onSuccess={handleUploadSuccess}
      data={{
        style: imageStyle,
        ...extraData
      }}
      onError={handleUploadError}
      multiple={multiple}
      draggable
      withCredentials
      fileListVisible={false}
    >
      <div
        style={computedContainerStyle}
      >
        {children}
      </div>
    </Uploader>
  )
}
